import { render, staticRenderFns } from "./Pos_paper_tax_invoices_sale.vue?vue&type=template&id=045fb169&scoped=true&"
import script from "./Pos_paper_tax_invoices_sale.vue?vue&type=script&lang=js&"
export * from "./Pos_paper_tax_invoices_sale.vue?vue&type=script&lang=js&"
import style0 from "./Pos_paper_tax_invoices_sale.vue?vue&type=style&index=0&id=045fb169&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045fb169",
  null
  
)

export default component.exports